export default __webpack_public_path__ + "static/media/rocket_anim_151.061fd401.png";